import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import riskManagementPolicyPdf from "../../../../assets/tenders/resource/RISK_MANAGEMENT_POLICY_OF_NMDFC.pdf";
import boardMembersTrainingPolicyPdf from "../../../../assets/tenders/resource/resource_Documents/Policy on Training for Board Members.pdf";

const nmdfcPolicyDocuments = [
  {
    serial: 1,
    title: "Risk Management Policy",
    fileName: "RISK_MANAGEMENT_POLICY_OF_NMDFC.pdf",
    href: riskManagementPolicyPdf,
  },
  {
    serial: 2,
    title: "Policy on Training for Board Members",
    fileName: "Policy on Training for Board Members.pdf",
    href: boardMembersTrainingPolicyPdf,
  },
];

const NmdfcPolicies = () => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-3 text-[18px] font-bold text-[#005856]">
      Policies
    </h2>
    <PdfDocumentTable documents={nmdfcPolicyDocuments} minWidth="680px" />
  </section>
);

export default NmdfcPolicies;
